// extracted by mini-css-extract-plugin
module.exports = {"videoEmbed":"VideoEmbed_videoEmbed__G_zL9","videoEmbedWeb3Theme":"VideoEmbed_videoEmbedWeb3Theme__9JG1U","player":"VideoEmbed_player__UV7sx"};